'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentType, type ReactNode, useState } from 'react';
import { type CustomDialogProps } from '@shared/ui-components/dialog/dialog';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { ProfilePhotoWithBadge } from '@shared/ui-components/profile-photo-with-badge/profile-photo-with-badge';
import { type ProfilePhotoContentType, type ProfilePhotoSize } from '@shared/ui-components/profile-photo/profile-photo';
import { type ServerActionResponse } from '@shared/utils/types/server-action';
import { ProfilePhotoDialog } from './profile-photo-dialog';
import { type ProfilePhotoDialogContentType } from './profile-photo-dialog-content';
export type ProfilePhotoContainerContent = ProfilePhotoContentType & ProfilePhotoDialogContentType & {
  add: string;
  change: string;
  close: string;
  edit: string;
  fileServerError: string;
  fileSizeError: null | string | undefined;
  fileTypeError: null | string | undefined;
  modalTitle: string;
  remove: string;
  save: string;
  upload: string;
};
export type PhotoUploadResponse = null | Response | ServerActionResponse;
export type ProfilePhotoContainerProps = {
  abortOngoingRequests: () => void;
  badge?: ReactNode;
  cmsContent: ProfilePhotoContainerContent;
  dialogComponent: ComponentType<CustomDialogProps>;
  handleProfilePictureDelete: () => Promise<ServerActionResponse>;
  handleSubmitProfilePicture: (formData: BodyInit) => Promise<PhotoUploadResponse>;
  initialProfilePicture: null | string;
  size?: ProfilePhotoSize;
};
export const ProfilePhotoContainer = t0 => {
  const $ = _c(27);
  let abortOngoingRequests;
  let badge;
  let cmsContent;
  let dialogComponent;
  let initialProfilePicture;
  let restProfilePhotoDialogProps;
  let size;
  if ($[0] !== t0) {
    ({
      abortOngoingRequests,
      badge,
      cmsContent,
      dialogComponent,
      initialProfilePicture,
      size,
      ...restProfilePhotoDialogProps
    } = t0);
    $[0] = t0;
    $[1] = abortOngoingRequests;
    $[2] = badge;
    $[3] = cmsContent;
    $[4] = dialogComponent;
    $[5] = initialProfilePicture;
    $[6] = restProfilePhotoDialogProps;
    $[7] = size;
  } else {
    abortOngoingRequests = $[1];
    badge = $[2];
    cmsContent = $[3];
    dialogComponent = $[4];
    initialProfilePicture = $[5];
    restProfilePhotoDialogProps = $[6];
    size = $[7];
  }
  const [profilePictureInSection, setProfilePictureInSection] = useState(initialProfilePicture ?? undefined);
  let t1;
  if ($[8] !== abortOngoingRequests) {
    t1 = isOpen => {
      if (!isOpen) {
        abortOngoingRequests();
      }
    };
    $[8] = abortOngoingRequests;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== badge || $[11] !== cmsContent.edit || $[12] !== cmsContent.photoCropAriaLiveText || $[13] !== cmsContent.pictureDescription || $[14] !== cmsContent.upload || $[15] !== profilePictureInSection || $[16] !== size) {
    t2 = t3 => {
      const {
        handleModalOpen,
        ...restTriggerProps
      } = t3;
      return <ProfilePhotoWithBadge badge={badge} handleModalOpen={handleModalOpen} profilePhotoProps={{
        actionLabelText: profilePictureInSection ? cmsContent.edit : cmsContent.upload,
        cmsContent: {
          photoCropAriaLiveText: cmsContent.photoCropAriaLiveText,
          pictureDescription: cmsContent.pictureDescription
        },
        hasHoverOverlay: Boolean(profilePictureInSection),
        imageSrc: profilePictureInSection,
        size
      }} {...restTriggerProps} />;
    };
    $[10] = badge;
    $[11] = cmsContent.edit;
    $[12] = cmsContent.photoCropAriaLiveText;
    $[13] = cmsContent.pictureDescription;
    $[14] = cmsContent.upload;
    $[15] = profilePictureInSection;
    $[16] = size;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== cmsContent || $[19] !== dialogComponent || $[20] !== profilePictureInSection || $[21] !== restProfilePhotoDialogProps) {
    t3 = handleModalClose => <ProfilePhotoDialog cmsContent={cmsContent} DialogComponent={dialogComponent} handleModalClose={handleModalClose} initialProfilePicture={profilePictureInSection} setProfilePictureInSection={setProfilePictureInSection} {...restProfilePhotoDialogProps} />;
    $[18] = cmsContent;
    $[19] = dialogComponent;
    $[20] = profilePictureInSection;
    $[21] = restProfilePhotoDialogProps;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] !== t1 || $[24] !== t2 || $[25] !== t3) {
    t4 = <ModalTrigger onOpenChange={t1} renderTrigger={t2}>{t3}</ModalTrigger>;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  return t4;
};